<template>
 <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Verify Your Email</h1>
              <p class="text-lead text-white">{{message}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <div class="container mt--8 pb-5">
      <!-- Table -->
      <div class="row justify-content-center">
        <div class="col-lg-6 col-md-8">
          	<div style="min-height:300px;"></div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  
 export default {
    components: {
  
    },
    data() {
      return {
      	 success: 5,
      	 message: 'Checking your verification link ...',
     	 officers:[],
	
      };
    },
    methods: {
      initBigChart(index) {

      }
    },
    mounted() {
      	swal.showLoading();
      	let uri = this.$base_url+'/api/v1/c/verify-email/'+ this.$route.params.cid+"/"+this.$route.params.sig;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.success = response.data.success;
      		 this.message = response.data.message;
      		 swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style>
</style>
